import { render, staticRenderFns } from "./LiveStudentSalesData.vue?vue&type=template&id=03d5c290&scoped=true"
import script from "./LiveStudentSalesData.vue?vue&type=script&lang=js"
export * from "./LiveStudentSalesData.vue?vue&type=script&lang=js"
import style0 from "./LiveStudentSalesData.vue?vue&type=style&index=0&id=03d5c290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d5c290",
  null
  
)

export default component.exports